import { useState, useRef, useCallback } from 'react'

const usePageLayout = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const statusCardRef = useRef<HTMLDivElement>(null)
  const productCardRef = useRef<HTMLDivElement>(null)
  return {
    wrapperRef,
    statusCardRef,
    productCardRef,
  }
}

export default usePageLayout
